import { render, staticRenderFns } from "./SampleOrders.vue?vue&type=template&id=438c03ce"
import script from "./SampleOrders.vue?vue&type=script&lang=js"
export * from "./SampleOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports